/*
  CarrierRequest.js - Service Config - Carrier Networking File

  Contains networking functionality for Service Config - Carrier Component
*/

// OUR MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

const useCarrierReportsRequest = () => {
  /*
    Creates a new Carrier for the given Country Code Id.
  */
  const getCarrierReportsData = async (searchParams, errorHandler) => {
    let url = `${config.baseServerURL}/admin/report/carrier`;
    const headers = new Headers({
      'Content-Type': 'application/json',
    });
    const options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(searchParams),
    };
    let response = await RequestRabbit.request(url, options, errorHandler);
    let responseJSON = await response?.json();

    return responseJSON;
  };

  /*
    Updates a Carrier
  */
  const getCarrierDetailReportsData = async (searchParams, errorHandler) => {
    let url = `${config.baseServerURL}/admin/report/carrier/detail`;
    const headers = new Headers({
      'Content-Type': 'application/json',
    });
    const options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(searchParams),
    };
    let response = await RequestRabbit.request(url, options, errorHandler);
    let responseJSON = await response?.json();

    return responseJSON;
  };

  const exportCarrierReport = async (searchParams, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/report/carrier/export`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'POST',
        body: JSON.stringify(searchParams) || null,
        headers: headers,
      };

      // Request
      const response = await RequestRabbit.request(url, options, errorHandler);
      return await response.text();
    } catch (e) {
      errorHandler(e);
    }
  };

  return {
    getCarrierReportsData,
    getCarrierDetailReportsData,
    exportCarrierReport,
  };
};

export default useCarrierReportsRequest;
